export const UserStateConstants = {
  FilterStateName: 'userFilter',
};

export const UserFilterActions = {
  SetFilter: 'SET_USER_FILTER',
};
